<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a v-if="id" class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i v-if="id" class="right angle icon divider"></i>
    <a v-if="id" class="active" v-on:click="goTo('/local')">Locals</a>
    <i v-if="id" class="right angle icon divider"></i>
    <a v-if="id" class="active section">Usuarios</a>
    <!-- <a class="section" v-on:click="goTo('/users')">Usuarios</a>
    <i v-if="id" class="right angle icon divider"></i>
    <a v-if="id" class="active" v-on:click="goTo('/corporations')">Corporaciones</a>
    <i class="right angle icon divider"></i> -->
<!--    <a class="active section">Usuarios</a>-->
  </div>
  <h1 class="ui header"><i class="icon users"></i>
    <div class="content">Usuarios</div>
  </h1>
  <!--
  <button v-if="id" class="ui basic button rightButton" v-on:click="goTo('/local/'+id+'/users/add')">
    <i class="icon user"></i>Añadir Usuario
  </button>
  -->
  <button v-if="!id" class="ui basic button rightButton" v-on:click="goTo('/local/users/add')">
    <i class="icon user"></i>Añadir Usuario
  </button>
  <div v-if="!users" class="ui active centered inline loader"></div>
  <div v-if="users" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <table class="ui very basic compact selectable collapsing table">
          <thead>
            <tr>
              <th class="azpian">Nombre</th>
              <th class="azpian">Teléfono</th>
              <th class="azpian">Email</th>
              <th class="azpian">Administrador</th>
              <th class="azpian">Activo</th>
              <th class="right aligned">
                <div class="ui category search">
                  <div class="ui icon input field">
                    <input class="prompt" type="text" v-model="search" placeholder="Buscar usuario" @change="filteredList">
                    <i class="search icon"></i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                {{user.LocalUser.name}}
              </td>
              <td>
                {{user.LocalUser.phone}}
              </td>
              <td>
                {{user.LocalUser.email}}
              </td>
              <td>
                <h2><i v-if="user.Administrator.role == 'localAdmin'" class="hapiick check icon"></i>
                  <i v-if="user.Administrator.role == 'localUser'" class="red times icon"></i>
                </h2>
              </td>
              <td>
                <h2><i v-if="user.LocalUser.active" class="hapiick check icon"></i>
                  <i v-if="!user.LocalUser.active" class="red times icon"></i>
                </h2>
              </td>
              <!--<td class="right aligned">-->
              <!--<td v-if="!id" class="center aligned">-->
              <td class="center aligned">
                <div class="ui button" v-on:click="userInfo(id, user.LocalUser.id)">Editar</div>
                <!-- <div class="ui button" v-on:click="goTo('/users/' + user.LocalUser.id + '/edit')">Editar</div> -->
                <!-- <div v-if="user.CorporationsUser.active" class="ui button blue" v-on:click="checkApmCapacity(user.CorporationsUser.id)">Generar paquete</div> -->
              </td>
              <!--<td v-if="id">
                <div class="ui button" v-on:click="goTo('/local/'+id+'/users/' + user.LocalUser.id+'/info')">Editar</div>
              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'localUsers',
  props: ['id'],
  data() {
    return {
      users: null,
      allUsers: null,
      search: null,
      inputOptions: {},
      token:null,
      parcelId:null
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin' || role === 'localAdmin') {
      this.getLocalUsers()
    } else {
      this.$router.replace('/parcels')
    }
  },
  methods: {
    getLocalUsers() {
      hapiickApi().post('/v2/locals/users', {
        admin_id: JSON.parse(localStorage.admin).id,
        localId: this.id,
      })
      .then((request) => {
        this.users = JSON.parse(JSON.stringify(request.data.users));
        this.allUsers = this.users;
      })
      .catch((request) => console.log('error getting local uses: ' + request))
    },
    goTo(where) {
      this.$router.push(where)
    },
    filteredList() {
      let userlist = []
      if (this.search.length === 0) {
        this.users = this.allUsers;
      } else {
        this.users = this.allUsers.filter((user) => user.LocalUser.name.toLowerCase().includes(this.search.toLowerCase()))
      }
    },
    userInfo(localId,userId) {
      //let userInfo = this.users.find(user => user.LocalUser.id == userId)
      //this.$router.push({name: 'localUserInfo', params: {id: id, theUserInfo: userInfo.LocalUser}})

      if(localId){
        //this.goTo('/local/'+localId+'/users/'+userId+'/info', 'localUserInfo')
        this.goTo('/users/'+localId+'/edit/'+userId, 'editUser')
      } else {
        this.goTo('/local/users/info/'+userId, 'localUserInfo')
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Local/localUsers.vue